import { get } from 'lodash';
import AuthNPolicyType, { formatAuthNPolicyForApi } from 'client/Security/AuthNPolicyType';
import CollectionApi from 'client/api/v2/CollectionApi';

class AuthNPoliciesApi extends CollectionApi {
  constructor() {
    super('/api/v2/authn/policies', {
      skip: 0,
      limit: 100,
      sort: 'name', // Prepend with a '-' to reverse default sort direction
    // searching, searchTerm all not implemented in API yet
    // -- MC 9/1/2020
    // search: {
    //   fields: [
    //     'name',
    //   ],
    //   searchTerm: '',
    // },
    });
  }

  async fetch(...args) {
    const res = await super.fetch(...args);

    if (Array.isArray(res.results)) {
      res.results = res.results.map(item => new AuthNPolicyType(item));
    }

    return res;
  }

  async fetchAll() {
    try {
      const items = await super.fetchAll();

      return items.map(item => new AuthNPolicyType(item));
    } catch (error) {
      const message = get(error, 'response.data.message', 'Failed to get policies');

      throw Error(message);
    }
  }

  async fetchItem(id) {
    const item = await super.get(id);
    return new AuthNPolicyType(item);
  }

  async create(item) {
    const apiItem = formatAuthNPolicyForApi(item);
    return super.create(apiItem);
  }

  async update(item) {
    const apiItem = formatAuthNPolicyForApi(item);
    return super.patch(apiItem.id, apiItem)
      .catch((err) => {
        const message = get(err, 'response.data.message', 'Failed to update policy');

        throw Error(message);
      });
  }
}

export default new AuthNPoliciesApi();
